import React from "react";
import { Line } from "rc-progress";
import { useGetMinimumOrderAmount } from "../../hooks";
import { useCartData } from "../../providers/cartDataStore";
import cx from "classnames";
import useWindowSize from "../../utils/useWindowSize";

interface CartProgressBarProps {
  lineClassName?: string;
}

const CartProgressBar = ({ lineClassName }: CartProgressBarProps) => {
  const { width } = useWindowSize();
  const { cartTotalValue } = useCartData();

  const { minimumOrderAmount } = useGetMinimumOrderAmount();
  const percentage = (cartTotalValue / minimumOrderAmount) * 100;

  const isMobile = width < 680;

  return (
    <Line
      trailWidth={1}
      trailColor="#EEEEEE"
      percent={percentage}
      strokeColor="#89D55B"
      strokeLinecap="square"
      className={cx(lineClassName)}
      strokeWidth={isMobile ? 1.2 : 0.7}
    />
  );
};

export default CartProgressBar;
